var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("敬请期待xxxxxxxxxx "+_vm._s(_vm.name)+_vm._s(_vm.data.name))])}
var staticRenderFns = []

export { render, staticRenderFns }